import React, { useState } from 'react';

import { UserAvatar } from './UserAvatar.view';

export const UserAvatarContainer: React.FC<{
  email?: string;
  title?: string;
  className?: string;
}> = (props) => {
  const [showDefault, setShowDefault] = useState(false);

  const handleNoGravatar = () => {
    setShowDefault(true);
  };

  return <UserAvatar {...props} handleError={handleNoGravatar} showDefault={showDefault} />;
};
